'use strict'

/**
 * SwatchSelectionState
 *
 * Holds the currently selected swatch datasets used by the visualizer.
 * This is state only (no rendering / DOM work).
 *
 * Terminology:
 * - "swatch" = color chart dataset (swatch_pages -> swatch_colors).
 * - "textureSwatch" = texture/effect dataset (texture_pages -> textures).
 */
class SwatchSelectionState {
    constructor() {
        /**
         * Currently selected color chart dataset.
         * Expected shape: { id, swatch_pages: [...], texture_pages?: [...] }
         * @type {Object|undefined}
         */
        this._currentSwatch = undefined

        /**
         * Server ID of the current color chart dataset.
         * @type {number|string|undefined}
         */
        this._currentSwatchId = undefined

        /**
         * Currently selected texture-swatch dataset.
         * Expected shape: { id, texture_pages: [...] }
         * @type {Object|undefined}
         */
        this._currentTextureSwatch = undefined

        /**
         * Server ID of the current texture-swatch dataset.
         * @type {number|string|undefined}
         */
        this._currentTextureSwatchId = undefined
    }

    /**
     * Returns true if the current swatch is a texture-based swatch (has color_filename on first color).
     * @returns {boolean}
     */
    hasSwatchTextureFilenames() {
        const filename = this.currentSwatch?.swatch_pages?.[0]?.swatch_colors?.[0]?.color_filename
        return Boolean(filename)
    }

    // ---------------------------------------------------------------------
    // GETTERS / SETTERS
    // ---------------------------------------------------------------------

    set currentSwatch(swatch) {
        this._currentSwatch = swatch
    }

    get currentSwatch() {
        return this._currentSwatch
    }

    set currentSwatchId(serverId) {
        this._currentSwatchId = serverId
    }

    get currentSwatchId() {
        return this._currentSwatchId
    }

    set currentTextureSwatchId(serverId) {
        this._currentTextureSwatchId = serverId
    }

    get currentTextureSwatchId() {
        return this._currentTextureSwatchId
    }

    set currentTextureSwatch(textureSwatch) {
        this._currentTextureSwatch = textureSwatch
    }

    get currentTextureSwatch() {
        return this._currentTextureSwatch
    }
}

export default SwatchSelectionState
